import css from './notifications.module.scss'

import ApplicationController from './application_controller.js'
export default class NotificationsController extends ApplicationController {

  connect() {
    this.top = 40
  }

  disconnect() {
  }

  notify(text) {
    var el = this.create_elem(text)
    this.element.appendChild(el)

    var rect = el.getBoundingClientRect()
    var left = window.innerWidth - rect.width - 30
    el.style.left = `${left}px`
    this.top += rect.height + 10
    setTimeout(() => {
      this.top -= (el.getBoundingClientRect().height + 10)
      this.element.removeChild(el)
    }, 2000, el)
  }

  create_elem(text) {
    var el = document.createElement('div')
    el.innerHTML = text
    el.style.top = `${window.scrollY + this.top}px`
    el.style.width = '300px'
    el.classList.add(css.notification)
    return el
  }

}